module.exports = __webpack_public_path__ + "static/media/twitter_grey.ff22d37b.png";